<template>
  <section>
    <OnClickOutside @trigger="ui.showOptions = false">
      <div class="relative mt-1">
        <button
          type="button"
          @click="ui.showOptions = !ui.showOptions"
          class="relative w-full cursor-default rounded-md border border-solid border-linear-subtle bg-surface-primary py-2 pl-3 pr-10 text-left text-sm focus:border-gray-40 focus:outline-none focus:ring-1 focus:ring-gray-30"
        >
          <span class="flex items-center">
            <template v-if="hasIcon">
              <SeatBulb :status="selectedValue" />
            </template>
            <span class="block capitalize" :class="{ 'ml-3': hasIcon }">{{ selectedText }}</span>
          </span>
          <span class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
            <!-- Chevron-Up-Down -->
            <svg
              class="h-5 w-5 text-fg-tertiary"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
        </button>
        <ul
          class="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-surface-primary py-1 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          :class="[ui.showOptions ? 'block' : 'hidden']"
        >
          <ListBoxOption
            v-for="(option, key) in options"
            :key="key"
            :option="option"
            :hasIcon="hasIcon"
            :itemText="itemText"
            :itemValue="itemValue"
            @listBoxOptionChange="changeListOption"
            class="hover:cursor-pointer"
          />
        </ul>
      </div>
    </OnClickOutside>
  </section>
</template>
<script lang="ts">
import { OnClickOutside } from '@vueuse/components'
import { PropType, defineComponent } from 'vue'

import ListBoxOption from '@/common/components/atoms/ListboxOption.vue'
import SeatBulb from '@/components/seat/SeatBulb.vue'

export default defineComponent({
  name: 'ListBox',
  components: {
    ListBoxOption,
    SeatBulb,
    OnClickOutside,
  },
  props: {
    hasIcon: { type: Boolean, required: false, default: false },
    options: { type: Array as PropType<any[]>, required: true },
    selected: { type: Object as PropType<any>, required: false },
    itemText: { type: String, required: false, default: 'text' },
    itemValue: { type: String, required: false, default: 'value' },
    blankText: { type: String, default: '' },
  },
  data() {
    return {
      ui: {
        showOptions: false,
      },
    }
  },
  computed: {
    selectedText(): string {
      if (!this.selected) return this.blankText
      return this.selected[this.itemText]
    },
    selectedValue(): string {
      return this.selected[this.itemValue]
    },
  },
  methods: {
    changeListOption(e) {
      this.ui.showOptions = false
      this.$emit('listBoxChange', e)
    },
  },
})
</script>
<style lang="scss">
ul {
  padding: 5px;
}
</style>
